import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'payment_status',
})
export class StatusPipe implements PipeTransform {
    transform(type: number) {
        if (type == 0) {
            return 'Unpaid'
        } else if (type == 1) {
            return 'Paid'
        }
        return type
    }
}
